module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/philosophy01-60c375b0a6a4fb446c3e93f7d8401ad2.png";